// extracted by mini-css-extract-plugin
export default {"icone":"songs_icone__3ylTM","navSong":"songs_navSong__8npeG"};